module.exports = __webpack_public_path__ + "static/2-6c26454689e587256b6786316438541c.png";